module.exports = __webpack_public_path__ + "img/highAltitude-icon2.f0a71381.png";